import { useContext } from 'react';
import { CurrencyContext } from '../providers/currency.provider';

export const useCurrency = () => {
  const context = useContext(CurrencyContext);
  if (!context) throw new Error('useCurrency debe ser utilizado dentro de un CurrencyProvider');
  return context;
};
